module.exports = __webpack_public_path__ + "static/media/shell32_25.55d0c454.ico";